import {useFonts} from 'expo-font';

export function useAppFonts() {
  return useFonts({
    'DIN Next LT Arabic': require('../../assets/fonts/din-next-regular.ttf'),
    'DIN Next LT Arabic Medium': require('../../assets/fonts/din-next-medium.ttf'),
    'DIN Next LT Arabic SemiBold': require('../../assets/fonts/din-next-bold.ttf'),
    'DIN Next LT Arabic Bold': require('../../assets/fonts/din-next-bold.ttf'),
  });
}
